import { createHttpActions } from '@next/arable-lib/shared';
import { createAction } from '@ngrx/store';

import { BlightData, ParticipatingCropField } from '../models/models';

export const [
  loadBlightData,
  loadBlightDataSuccess,
  loadBlightDataFailure,
] = createHttpActions<{ from: Date; to: Date }, { data: BlightData[] }, { message: string }>(
  'Load Blight Data',
);

export const loadBlightDataIgnored = createAction(
  'Load Blight Data Ignored',
);

export const resetBlightData = createAction(
  'Reset Blight Data',
  (payload: { from: Date; to: Date }) => ({ payload }),
);

export const [
  loadParticipatingCropFields,
  loadParticipatingCropFieldsSuccess,
  loadParticipatingCropFieldsFailure,
] = createHttpActions<{ cropYear: number; }, {
  cropFields: ParticipatingCropField[]
}, void>('Load Participating Crop Fields')
